/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BackgroundElement from '../components/BackgroundElement';
import BannerCategory from '../components/BannerCategory';
import BannerImage from '../components/BannerImage';
import BannerLinkButton from '../components/BannerLinkButton';
import BannerOverline from '../components/BannerOverline';
import BannerTeaser from '../components/BannerTeaser';
import BannerTitle from '../components/BannerTitle';
import Disruptor from '../components/Disruptor';
import LinkWrapper from '../components/LinkWrapper';
import AbstractLayout from './AbstractLayout';

export default class NewReadingRound extends AbstractLayout {
	get key() {
		return 'new_reading_round';
	}

	content() {
		const { banner } = this.attrs;

		return (
			<LinkWrapper banner={banner}>
				<div className="Banner-content">
					<BackgroundElement banner={banner} />

					<div className="BannerContentContainer">
						<BannerTitle banner={banner} />
						<BannerOverline banner={banner} />
						<BannerTeaser banner={banner} />
						<BannerCategory banner={banner} />
						<Disruptor banner={banner} />
						<BannerLinkButton banner={banner} />
					</div>

					<BannerImage banner={banner} />
				</div>
			</LinkWrapper>
		);
	}
}
